/**
 * useIncome — income summary store (Zustand).
 * Fetches /api/income/summary and caches it in memory.
 */
import { create } from 'zustand'
import { getIncomeSummary } from '@/lib/api'
import type { IncomeSummaryResponse } from '@/lib/types'

interface IncomeState {
  summary: IncomeSummaryResponse | null
  loading: boolean
  error: string | null
  fetch: () => Promise<void>
}

export const useIncome = create<IncomeState>()((set) => ({
  summary: null,
  loading: false,
  error: null,

  fetch: async () => {
    set({ loading: true, error: null })
    try {
      const summary = await getIncomeSummary()
      set({ summary, loading: false })
    } catch (e) {
      set({ error: String(e), loading: false })
    }
  },
}))
